<script setup>
import { computed } from 'vue'
import { audiences, teasers } from '../audiences'

// Short links to the other audience landings, placed right under the first screen.
const props = defineProps({ current: { type: String, required: true } })
// Ordered as listed in `teasers`: the most relevant alternative goes first.
const items = computed(() => Object.entries(teasers[props.current] || {})
  .map(([name, copy]) => ({ ...audiences.find(item => item.name === name), ...copy })))
</script>

<template>
  <nav class="audience-teaser" aria-label="Другие способы играть">
    <RouterLink v-for="item in items" :key="item.name" class="audience-teaser-link" :class="`audience-teaser-${item.name}`" :to="`/${item.name}`">
      <img :src="item.image" alt="" loading="lazy" />
      <span><strong>{{ item.question }}</strong>{{ item.answer }}</span>
      <i aria-hidden="true">→</i>
    </RouterLink>
  </nav>
</template>
